import React from 'react';
import { Avatar as OriAvatar } from 'appkit-react';
import PropTypes from 'prop-types';

function Avartar(props) {
  const { name, title, showInfo } = props;
  const Iconfont = (name || 'A')[0];
  return (
    <div className="avatar-wrapper">
      <OriAvatar label={Iconfont} />
      {showInfo && (
        <div className="info-content">
          <span className="name">{name}</span>
          <span className="title">{title}</span>
        </div>
      )}
    </div>
  );
}

Avartar.defaultProps = {
  name: '',
  title: '',
  showInfo: true,
};

Avartar.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  showInfo: PropTypes.bool,
};

export default Avartar;
